// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__p8shl","location":"Header_location__TAXBI"};